export function getOrPossiblyCreateUserByUsername(username: string) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/users/get-or-possibly-create-user-by-username/${username}`,
    returnRaw: true,
  }
}
